import { formatMoney } from "@/utils/StringUtils";
import { Skeleton, styled } from "@mui/material";
import { useCheckoutCartInfo } from "../../hooks/useCheckoutCartInfo";
import { useAsyncCheckoutEnabled } from "../../hooks/useAsyncCheckoutEnabled";

const TotalContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  color: theme.vars.palette.text.primary,
}));

const TotalRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "14px",
  color: theme.vars.palette.text.primary,
}));

const TotalRowBold = styled(TotalRow)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  marginTop: "4px",
  paddingTop: "12px",
  color: theme.vars.palette.text.primary,
  borderTop: `1px solid ${theme.vars.palette.text.primary}`,
}));

export const CartTotal = () => {
  const info = useCheckoutCartInfo();

  const { debug } = useAsyncCheckoutEnabled();

  const {
    subtotal,
    estimatedShipping,
    estimatedTax,
    amountToCharge,
    items,
    deliveryEstimate,
    source,
    checkoutSummaryLoading,
    serviceFee,
  } = info;

  if (checkoutSummaryLoading) {
    return (
      <TotalContainer>
        <TotalRow>
          <Skeleton width={"30%"} />
          <Skeleton width={"20%"} />
        </TotalRow>
        <TotalRow>
          <Skeleton width={"34%"} />
          <Skeleton width={"15%"} />
        </TotalRow>
        <TotalRow>
          <Skeleton width={"25%"} />
          <Skeleton width={"15%"} />
        </TotalRow>
        <TotalRow>
          <Skeleton width={"20%"} />
          <Skeleton width={"15%"} />
        </TotalRow>
        <TotalRowBold>
          <Skeleton width={"15%"} />
          <Skeleton width={"25%"} />
        </TotalRowBold>
      </TotalContainer>
    );
  }

  return (
    <TotalContainer>
      <TotalRow>
        <span>
          Subtotal ({items?.length} item{items?.length === 1 ? "" : "s"})
        </span>
        <span>{formatMoney(subtotal)}</span>
      </TotalRow>
      <TotalRow>
        <span>Shipping fee ({`${deliveryEstimate || "2-5 days"}`})</span>
        <span>{formatMoney(estimatedShipping)}</span>
      </TotalRow>
      <TotalRow>
        <span>Estimated tax</span>
        <span>{formatMoney(estimatedTax)}</span>
      </TotalRow>
      <TotalRow>
        <span>Service fee</span>
        <span>{formatMoney(serviceFee)}</span>
      </TotalRow>
      <TotalRowBold>
        <span>Total</span>
        <span>{formatMoney(amountToCharge)}</span>
      </TotalRowBold>
      {debug && (
        <TotalRow>
          <span>Source</span>
          <span>{source}</span>
        </TotalRow>
      )}
    </TotalContainer>
  );
};
